import { Box, Container, Link, Typography } from '@mui/material';

const links = [
  {
    label: '運営会社',
    href: 'https://www.master-apps.jp/company/'
  },
  // {
  //   label: '利用規約',
  //   href: 'https://www.master-apps.jp/cms/wp-content/themes/master_apps/pdf/MasterReport_Terms.pdf'
  // }
];

export const Footer = () => (
  <div>
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        flexDirection: {
          sm: 'row',
          xs: 'column'
        },
        py: 3,
        '& a': {
          mt: {
            sm: 0,
            xs: 1
          },
          '&:not(:last-child)': {
            mr: {
              sm: 5,
              xs: 0
            }
          }
        }
      }}
    >
      <Typography
        color="textSecondary"
        variant="caption"
      >
        © 2023 STREET SMART Co., Ltd.
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      {links.map((link) => (
        <Link
          color="textSecondary"
          href={link.href}
          key={link.label}
          target="_blank"
          underline="none"
          variant="body2"
        >
          {link.label}
        </Link>
      ))}
    </Container>
  </div>
);
